import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { Loader } from '../../Defaults/Loader';

export interface Props {
  height?: number;
}

function LoaderWrapper({ height }: Props) {
  return (
    <Wrapper height={height}>
      <Loader loading={true} />
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)`
  width: 100%;
  height: ${({ height }: { height?: number }) =>
    height ? rem(height) : rem(100)};
`;

export { LoaderWrapper };
